var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute w-full h-1/4 from-[#ffffffff] to-[#ffffff00] transition-opacity duration-500 pointer-events-none",class:{
    'top-0 bg-gradient-to-b': _vm.position === 'top',
    'bottom-0 bg-gradient-to-t': _vm.position === 'bottom',
    'opacity-1': _vm.show,
    'opacity-0': !_vm.show
  }})}
var staticRenderFns = []

export { render, staticRenderFns }